import useGenesStore from '../../../../store/store';
import ChildrenItem from './ChildrenItem';

function ChildrenList() {
  const { result } = useGenesStore();

  if (typeof result === 'undefined') {
    return null;
  }

  return <ChildrenItem result={result} />;
}

export default ChildrenList;
